import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
    import { formatCurrency } from '@/utils/helpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableCurrency',
  props: {
    value: {},
    withColor: { type: Boolean, default: false },
    addon: {},
    returnZero: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const props = __props;

    const formattedValue = computed(() => {
        if (!props.value) return emptyValue.value;
        return formatCurrency(props.value);
    });

    const emptyValue = computed(() => {
        if (props.returnZero) return formatCurrency(0);
        return '';
    });

    const color = computed(() => {
        if (!props.value || !props.withColor) return '';
        return props.value < 0 ? 'text-destructive' : 'text-accent';
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(color.value)
  }, _toDisplayString(formattedValue.value) + " " + _toDisplayString(_ctx.addon), 3))
}
}

})